function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1)
  }
  return (
    s4() +
    s4() +
    '-' +
    s4() +
    '-' +
    s4() +
    '-' +
    s4() +
    '-' +
    s4() +
    s4() +
    s4()
  )
}

module.exports = guid



//////////////////
// WEBPACK FOOTER
// ./~/hubspot/lib/utils/guid.js
// module id = Pwm8
// module chunks = 1